import { sendPost } from '../http.js'
const api = {
	'helperMenu': {
        url: '/helper/menu'
    },
    'helpDetail': {
        url: '/helper/details'
    },
    'popupprompts': {
        url: '/user/user/popupprompts',
        mutationsName: 'changePopupprompts',
        stateName: 'popuppromptsStatus'
    },
    'ksAuthorize': {
        url: '/user/ks/authorize'
    },
    'codeList': {
        'url':'user/talent/codelist',
    },
    'qualificationCate': {
        url: '/qualification/cate'
    },
    'qualificationIndustry': {
        url: '/qualification/industry'
    },
    'qualificationCreate': {
        url: '/qualification/create'
    },
    'qualificationList': {
        url: '/qualification/list'
    },
    'qualificationInfo': {
        url: '/qualification/info'
    },
    'qualificationRecall':{
        url: '/qualification/recall'
    },
    'qualificationHistory': {
        url: '/qualification/history'
    },
    'qualificationIsAdd': {
        url: '/qualification/isadd',
        mutationsName: 'changeQualificationIsAdd',
        stateName: 'qualificationIsAddFlag',
        stateDefaultName: '',
        getStateName: 'isadd'
    },
    'qualificationLists': {
        url: '/v2/qualification/list' 
    },
    'qualificationCreate':{
        url:'v2/qualification/create'
    },
    'qualificationInfo':{
        url:'v2/qualification/info'
    },
    'qualificationClassList':{
        url:'v2/qualification/class_list'
    },
    'qualificationClassEdit':{
        url:'v2/qualification/class_edit'
    },
    'qualificationClassInfos':{
        url:'v2/qualification/class_info'
    },
    'quaCheck_authorization':{
        url:'v2/qualification/check_authorization'
    },
    'appendAuthorization':{
        url:'v2/qualification/append_authorization'
    },
    'upload_material':{
        url:'v2/qualification/upload_material'
    },
    'appointlistFun': { 
        url: '/user/user/appointlist'
    },
    'searchtalent': {
        url: '/user/user/searchtalent'
    },
    'addappoint': {
        url: '/user/user/addappoint '
    },
    'editappoint': {
        url:'/user/user/editappoint'
    },
	'wechatQcode': {
	    url:'/wechat/qcode'
	},
    'deletecode': {
	    url:'/user/talent/deletecode '
	},
    'shareAuthorList': {
        url: '/qualification/share_author_list'
    },
    'shareApply': {
        url: '/qualification/share_apply'
    },
    'shareApplyList': {
        url: '/qualification/share_apply_list'
    },
    'shareStatusAudit': {
        url: '/qualification/share_status_audit'
    },
    'shareStatus': {
        url: '/qualification/share_status'
    },
    'appointProduct': {
        url: '/user/user/appoint/product',
        method: 'get'
    },
    'userAppoint': {
        url: '/user/user/appoint',
        method: 'get'
    },
    'qualificationMove': {
        url: '/qualification/move'
    },
    'newCodelist': {
        url: '/user/talent/codelist/v2'
    },
    'qualislist': {
        url: '/user/qualis'
    },
    'unbindQuali': {
        url: '/user/talent/dycode/unbind/quali'
    },
    'bindQuali': {
        url: '/user/talent/dycode/bind/quali'
    },
    'qualificationDelete': {
        url: '/v2/qualification/del'
    },
    'qualificationAuthLetters': {
        url: '/v2/qualification/auth_letters'
    },
    'qualificationAuthRole': {
        url: '/v2/qualification/auth_role'
    },
    'agreement': {
        url: '/v2/qualification/agreement'
    },
    'auth_role_info': {
        url: '/v2/qualification/auth_role_info'
    },
    'auth_role_new': {
        url: '/v2/qualification/auth_role_new'
    },
    'getRelationOperateLogListAPI': { // 获取关联课程操作日志
        url: '/author/sms_product/relation_log'
    },
    'getTargetedPromotionChartsAPI': { // 获取定向推广制定达人折线图数据
        url: '/user/user/trend'
    },
}
const requestFunObj = {}
for (const key in api) {
    requestFunObj[key]  = {
        ...api[key],
        requestFun:(params,method, headers) => {
            return sendPost(api[key].url, params, method || api[key].method || 'post', headers)
        }
    } 
}
export default requestFunObj
